import React from 'react';
import PropTypes from 'prop-types';
import './FormTitleRow.scss'


export default function FormTitleChip({chip, className, ...props}) {
  return (
    <span className="form-title-chip rounded-circle" {...props}> {chip} </span>
  )
}

FormTitleChip.propTypes = {
  chip: PropTypes.any,
  className: PropTypes.string,
}